import { render, staticRenderFns } from "./SortablePlaylist.vue?vue&type=template&id=bacfe338&scoped=true&"
import script from "./SortablePlaylist.vue?vue&type=script&lang=js&"
export * from "./SortablePlaylist.vue?vue&type=script&lang=js&"
import style0 from "./SortablePlaylist.vue?vue&type=style&index=0&id=bacfe338&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bacfe338",
  null
  
)

export default component.exports